import styled from "styled-components";

import { TokenIcon } from "./token-icon";

export const TokenIconAdaptive = styled(TokenIcon)`
  path {
    fill: var(--icon-primary);
  }
`;
